import { ListTenantsResponse, Tenant } from '../gen/proto/api/gateway/v1/tenant_pb';
import { tenantClient } from './api-grpc';

const LIST_ALL_PAGE_SIZE = 100;

export const tenantApi = {
  async listTenants(): Promise<Tenant[]> {
    const tenants: Tenant[] = [];
    let pageIndex = 1;
    let totalCount = 0;
    do {
      const response = await tenantClient.listTenants({
        pagination: { pageIndex, pageSize: LIST_ALL_PAGE_SIZE },
      });
      if (!response.tenants || response.tenants.length === 0) {
        break;
      }
      tenants.push(...response.tenants);
      totalCount = response.metadata?.totalCount ?? tenants.length;
      pageIndex++;
    } while (tenants.length < totalCount);
    return tenants;
  },

  async listTenantsByPage(pageIndex: number, pageSize: number): Promise<ListTenantsResponse> {
    return await tenantClient.listTenants({
      pagination: { pageIndex, pageSize },
    });
  },

  async getTenantByUuid(uuid: string): Promise<Tenant> {
    const response = await tenantClient.getTenantByUuid({
      uuid,
    });
    if (!response.tenant) {
      throw new Error('No tenant found');
    }
    return response.tenant;
  },
  async createTenant(name: string): Promise<Tenant> {
    const response = await tenantClient.createTenant({ name });
    if (!response.tenant) {
      throw new Error('No tenant created');
    }
    return response.tenant;
  },

  async updateTenant(uuid: string, name: string): Promise<Tenant> {
    const response = await tenantClient.updateTenant({ uuid, name });
    if (!response.tenant) {
      throw new Error('No tenant found');
    }
    return response.tenant;
  },

  async deleteTenant(uuid: string): Promise<void> {
    await tenantClient.deleteTenant({ uuid });
  },
};
